const AGREEMENT_TYPE = {
  RENTAL_CONTRACT_AGREEMENT: 'rentalContractAgreement',
  MANDATE_CONTRACT_AGREEMENT: 'mandateContractAgreement',
};

const MANDATE_CONTRACT_TYPE = {
  TAXI: 'taxi',
  DELIVERY: 'delivery',
};

const TARIFF_ID = {
  DELIVERY: 'DELIVERY',
  DELIVERY_GLOVO: 'DELIVERY_GLOVO',
  DELIVERY_STUART: 'DELIVERY_STUART',
  DELIVERY_VIP: 'DELIVERY_VIP',
  DELIVERY_WOLT: 'DELIVERY_WOLT',
  DELIVERY_WOLT_VIP: 'DELIVERY_WOLT_VIP',
  TAXI: 'TAXI',
  TAXI_VIP: 'TAXI_VIP',
};

const TARIFF_TRANSLATION = {
  [TARIFF_ID.DELIVERY]: 'Раз в неделю / Доставка',
  [TARIFF_ID.DELIVERY_GLOVO]: 'Раз в неделю / Glovo',
  [TARIFF_ID.DELIVERY_STUART]: 'Раз в неделю / Stuart',
  [TARIFF_ID.DELIVERY_VIP]: 'Каждый день / Доставка',
  [TARIFF_ID.DELIVERY_WOLT]: 'Выплата по периодам / Wolt',
  [TARIFF_ID.DELIVERY_WOLT_VIP]: 'Каждый день / Wolt',
  [TARIFF_ID.TAXI]: 'Раз в неделю / Такси',
  [TARIFF_ID.TAXI_VIP]: 'Каждый день / Такси',
};

export { AGREEMENT_TYPE, MANDATE_CONTRACT_TYPE, TARIFF_ID, TARIFF_TRANSLATION };
